import { ChangeDetectorRef, Component, Input, OnInit,EventEmitter,Output,ViewRef } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router' 
import { MatDialog,MatSnackBar } from '@angular/material'
import * as _ from 'lodash'
import { of,Observable, Subject,  } from 'rxjs'
import { debounceTime, first ,distinctUntilChanged } from 'rxjs/operators'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'

import {FormControl } from '@angular/forms'
import {  DatePipe } from '@angular/common';
import { AppService } from "../../../../../services/app.service";
import { StateService } from '../../../../../services/state.service';

const KEY = 'search'

@Component({
	selector: 'atyl-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss'],
})

@Stringable({
	path: 'views/partials/content/general/search',
	key: KEY,
})
export class SearchComponent implements OnInit {

    
	@StringableValues(KEY)  strings: any
	
	  @Output() onTiersSelected = new EventEmitter<any>();
	 
	  @Input() disabled: boolean=true;
	 @Input() navigate:boolean=true;
	   
	   private debounce: Subject<string> = new Subject();
	   
	   tiersCtrl: FormControl = new FormControl();
	
	   autocompTiersList: any= {
	   		count:0,
	   		datas:[]
	   	  };
	loading_tiers:boolean=false;
	tierstype:string[]=[];
	connected:boolean=false;
	
	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		public dialog: MatDialog,
		private tiersService: AppService,
		private stateService: StateService,
		private datePipe: DatePipe,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		
	) { }

	ngOnInit() {
		this.stateService.type_tiers.subscribe((att:any) => {
			
			this.tierstype=Object.keys(att);
			if (this.tierstype.length>0) {
				this.disabled=false;
				console.log("SearchComponent init",att,this.tierstype)
				this._initTiersSearch();
			}
			
      	});
		
		this.stateService.user.subscribe((user:any) => {
			console.log("SearchComponent user",user)
			if (user!='' && user.accessToken !=undefined ) {
				this.connected=true
				this.changeDetectorRef.detectChanges();
			}
		})
		
	}

	ngOnDestroy() {
	//	this.eventsSubscription.unsubscribe()
		//this.eventReloadSubscription.unsubscribe()
	}
	
	detectChanges() {
	  	    //    setTimeout(() => {
	  	            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
	  	                this.changeDetectorRef.detectChanges()
	  	            }
	  	    //    })
	  }
	  
	  _initTiersSearch(){
	  			this.tiersCtrl.enable({onlySelf:true});
	  			
	  				this.tiersCtrl.valueChanges.pipe(
	  					debounceTime(1000),
	  					distinctUntilChanged()
	  				).subscribe(search => {
	  					console.log('SearchComponent search ', search);
	  					
	  					
	  					
	  					if (search!=undefined) {
	  						    this.loading_tiers=true;
	  							let _opts:any={
	  								tierstype: this.tierstype
	  							};
	  					        this.tiersService.getTiersList(search, _opts).subscribe((r:any) => {
	  					         if (r.result && r.result.datas!=undefined) {
	  								      
	  								
	  						          this.autocompTiersList = r.result;
	  								  console.log('SearchComponent search result ',  this.autocompTiersList);
	  						         // this.tempResCommuneList = result.result;
	  								 this.loading_tiers=false;
	  						          this.detectChanges()
	  								  }
	  					        });
	  						}			
	  				})
	  	}
	    
		displayAutoTiersList(key?: any): any | undefined {
			      console.log("displayAutoTiersList",key,this.autocompTiersList);
			      let selected;
			      if (key!=undefined && key &&
					this.autocompTiersList!=undefined && this.autocompTiersList.datas !=undefined
					&& key.ID!=undefined
				   ) {
			        
					let stop:boolean=false;
					 this.autocompTiersList.datas.forEach((select) => {
						if (!stop) {
							select.tiers.forEach((tr) => {
									if (!stop && tr.ID!=undefined && tr.ID==key.ID ) {
										stop=true;
										selected=tr;
									}
								});
							
						}
			          //if (select.key === key)
			           // selected = select;
			        })
			      }
				  
				 
				  
				  
				  return this._getLabelTiers(selected);
				  
				  //return (selected!=undefined) ? selected.NOM+" "+selected.PRENOM : undefined ;
			     // return selected ? selected.nom : undefined;
		}
		
		
	selectTiers(event: any) { 
		console.log('SearchComponent selecTiers event:',event)
		//this.selectedMember = event.ID ? event.ID : ''
		if (event.option!=undefined && event.option.value!=undefined && event.option.value
			 && event.option.value.dossierID!=undefined
			&& event.option.value.type!=undefined						
		 )	{
				var dossier:any=event.option.value;
				
				
				let url:string='/home/';
				
				
				
				let link:string='dossier/'+dossier.type;
				
				switch(dossier.type) {
					case 'ASSMAT':
						link='assistmat';break;
					case 'ASSFAM':
						link='assistfam';break;	
					case 'ASSMAT_MAM':
						link='amatam';break;			
					case 'EAJE':
						link='eaje';break;
					case 'MAM':
						link='mam';break;	
					case 'ENFANT':
						link='enfant';break;	
					case 'GESTIONNAIRE':
						link='gestionnaire';break;	
					case 'STRUCTURE_GESTION':
						link='structgestion';break;
					case 'RAM':
						link='ram';break;	
					case 'FORMATION':
						link='formation';break;		
					case 'RIPA':
						link='ripa';break;	
					case 'CA':
						link='ca';break;	
					case 'CCPD':
						link='ccpd';break;	
					case 'GAT':
						link='gat';break;										
				}
				url+=link+"/"+ dossier.dossierID;
				console.log('SearchComponent selecTiers dossier:',dossier,url)
											
				this.stateService.updateRefresh(true);
				 this.onTiersSelected.emit(dossier);
				 if (this.navigate)
					this.router.navigate([url], {
				    			relativeTo: this.activatedRoute
			})
		 }	else {
			if (!this.navigate)
				this.onTiersSelected.emit(null);
			
		 }
				
	}
		
		
		
		
	_getLabelTiers(selected:any) {
						
			if (selected!=undefined) {
				//console.log('_getLabelTiers',selected)
				let st:string[]=[];	
				if (selected.NOM!=undefined && selected.NOM)
					st.push(selected.NOM);
				if (selected.NOMMARITAL!=undefined && selected.NOMMARITAL)
					st.push(selected.NOMMARITAL);
				if (selected.PRENOM!=undefined && selected.PRENOM)
					st.push(selected.PRENOM);
				if (selected.DATENAISSANCE!=undefined && selected.DATENAISSANCE 
					&& selected.DATENAISSANCE.date!=undefined )
						st.push(this.datePipe.transform(selected.DATENAISSANCE.date,"dd/MM/yyyy"));
				if (selected.REFERENCE!=undefined && selected.REFERENCE )
					st.push(selected.REFERENCE);
				return st.join(" ");
			}
			return undefined;
	}
	
	



}
